import useDataset from "datasets/hooks/useDataset";

/**
 * Hook that returns `true` if the current user has the required dataset permission.
 * Checks the Catalog API's `actions_permitted` on the dataset (all actions are defined
 * in `DatasetActions` in schema.py and fully covered by the backend for owner-level access).
 *
 * @param permission a single dataset action (e.g. "create:catalog-report")
 * @returns
 */
const usePermissions = (permission: string): boolean => {
  const { data: dataset } = useDataset();
  return !!dataset?.actions_permitted.includes(permission);
};

export default usePermissions;
